import { render, staticRenderFns } from "./DetectionReport.vue?vue&type=template&id=1192c19b"
import script from "./DetectionReport.vue?vue&type=script&lang=js"
export * from "./DetectionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports